import axios from "axios";
import { trackEvent } from "../lib/analytics";
import { avisarPlanoBloqueado, isPlanoBloqueado } from "./planoBloqueado";

// Cliente axios único do app (autenticado). Substitui frontend/src/services/api.js —
// baseURL vem de env (nunca hardcoded), token lido do localStorage a cada request via
// interceptor (não precisa recriar a instância a cada chamada).
const httpClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:8080",
  headers: { "Content-Type": "application/json" },
});

httpClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isPlanoBloqueado(error)) {
      trackEvent("plano_bloqueado_402", { rota: error.config?.url });
      avisarPlanoBloqueado(error.response.data?.mensagem);
    }
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      if (!window.location.pathname.startsWith("/auth")) {
        window.location.assign("/auth/login?sessionExpired=1");
      }
    }
    return Promise.reject(error);
  }
);

export default httpClient;
